import {SET_SCORE} from "../types/score.types";

export function setScore(score) {
  return (dispatch) => {
    dispatch({ type: SET_SCORE, score });
  };
}